import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GestaoPublicacaoComponent } from './gestao-publicacao/gestao-publicacao.component';
import { PublicacaoAgendadaEnvioComponent } from './publicacao-agendada-envio/publicacao-agendada-envio.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter'

@NgModule({
  declarations: [GestaoPublicacaoComponent, PublicacaoAgendadaEnvioComponent],
  imports: [
    CommonModule,
    Ng2SearchPipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule
  ],
  exports: [
    GestaoPublicacaoComponent
  ]
})

export class GestaoPublicacaoModule { }
